export { default, CodeEditorSyntaxStyles } from './CodeEditor';
